import { useState } from 'react';

interface CopyableAddressProps {
  address: `0x${string}` | string;
  truncate?: boolean;
  showYou?: boolean;
  className?: string;
}

export function CopyableAddress({
  address,
  truncate = true,
  showYou = false,
  className = '',
}: CopyableAddressProps) {
  const [copied, setCopied] = useState(false);

  const displayAddress = truncate
    ? `${address.slice(0, 6)}...${address.slice(-4)}`
    : address;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(address);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (err) {
      console.error('Failed to copy address:', err);
    }
  };

  return (
    <button
      type="button"
      onClick={handleCopy}
      className={`copyable-address ${copied ? 'copied' : ''} ${className}`}
      title={`Click to copy: ${address}`}
      aria-label={`Copy address ${address}`}
    >
      <span className="copyable-address-text">{displayAddress}</span>
      {showYou && <span className="copyable-address-you">(you)</span>}
      <span className="copyable-address-icon" aria-hidden="true">
        {copied ? '✓' : '⧉'}
      </span>
      {copied && <span className="copyable-address-feedback">Copied!</span>}
    </button>
  );
}
